var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTablets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 27.3334L27.3334 14C27.9565 13.3895 28.4523 12.6614 28.7922 11.8581C29.1321 11.0547 29.3094 10.1919 29.3138 9.31955C29.3182 8.44723 29.1497 7.58269 28.8179 6.77591C28.4861 5.96914 27.9976 5.23615 27.3808 4.61931C26.764 4.00248 26.031 3.51405 25.2242 3.18225C24.4174 2.85046 23.5529 2.6819 22.6806 2.6863C21.8082 2.69071 20.9454 2.868 20.1421 3.20792C19.3387 3.54785 18.6107 4.04366 18.0001 4.66669L4.66675 18C4.04372 18.6106 3.54791 19.3386 3.20798 20.142C2.86806 20.9454 2.69077 21.8082 2.68636 22.6805C2.68196 23.5528 2.85052 24.4174 3.18232 25.2241C3.51411 26.0309 4.00254 26.7639 4.61937 27.3807C5.23621 27.9976 5.9692 28.486 6.77598 28.8178C7.58275 29.1496 8.44729 29.3182 9.31961 29.3137C10.1919 29.3093 11.0547 29.1321 11.8581 28.7921C12.6615 28.4522 13.3895 27.9564 14.0001 27.3334Z",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 11.3333L20.6666 20.6666",
    stroke: "white",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablets);
export default __webpack_public_path__ + "static/media/tablets.388dab413e1647ff01d2e7c548992b37.svg";
export { ForwardRef as ReactComponent };